console.log("[trk] google-checkout-tracking.js loaded");

(function () {
  const COOKIE_PREFIX = "trk_";
  const KEYS = ["gclid", "wbraid", "gbraid"];
  const SESSION_FLAG = "trk_cart_attrs_synced_v2";

  function setCookie(name, value) {
    document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=7776000; SameSite=Lax; Secure`;
  }

  function getCookie(name) {
    const m = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    return m ? decodeURIComponent(m[2]) : null;
  }

  function hasSessionFlag() {
    try {
      return sessionStorage.getItem(SESSION_FLAG) === "1";
    } catch {
      return false;
    }
  }

  function setSessionFlag() {
    try {
      sessionStorage.setItem(SESSION_FLAG, "1");
    } catch {}
  }

  function readUrlParamsToCookies() {
    const params = new URL(window.location.href).searchParams;
    KEYS.forEach((k) => {
      const v = params.get(k);
      if (v) {
        console.log(`[trk] Found URL param: ${k}=${v}`);
        setCookie(`${COOKIE_PREFIX}${k}`, v);
      }
    });
  }

  function buildPayloadFromCookies() {
    const payload = {};
    KEYS.forEach((k) => {
      const v = getCookie(`${COOKIE_PREFIX}${k}`);
      if (v) {
        payload[`_${k}`] = v;
        console.log(`[trk] Found cookie: ${COOKIE_PREFIX}${k}=${v}`);
      }
    });
    return payload;
  }

  async function getCart() {
    const r = await fetch("/cart.js", { credentials: "same-origin" });
    if (!r.ok) throw new Error(`cart.js failed: ${r.status}`);
    return r.json();
  }

  function cartAlreadyHasPayload(cart, payload) {
    const attrs = (cart && cart.attributes) || {};
    return Object.keys(payload).every((k) => !!attrs[k]);
  }

  async function updateCartAttributes(payload) {
    const r = await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attributes: payload }),
      keepalive: true,
      credentials: "same-origin",
    });

    if (!r.ok) {
      console.warn("[trk] Failed to update cart attributes:", r.status);
      return false;
    }

    // Shopify renvoie du JSON, mais on ne dépend pas de son parsing pour décider succès
    await r.json().catch(() => null);
    console.log("[trk] Cart attributes updated successfully.");
    return true;
  }

  async function syncIfNeeded({ retries = 2 } = {}) {
    readUrlParamsToCookies();

    const payload = buildPayloadFromCookies();
    if (!Object.keys(payload).length) {
      console.log("[trk] No cookies found to sync to cart attributes.");
      return false;
    }

    // Même si flag présent, on vérifie quand même que le cart a bien les attrs.
    // (cart reset, clear, etc. peuvent casser la logique d'un flag naïf)
    let cart;
    try {
      cart = await getCart();
    } catch (e) {
      console.warn("[trk] Could not read cart.js:", e);
      // Si on ne peut pas lire le cart, on tente quand même l'update (best effort)
    }

    if (cart && cartAlreadyHasPayload(cart, payload)) {
      if (!hasSessionFlag()) setSessionFlag();
      console.log("[trk] Cart already contains tracking attributes. Nothing to do.");
      return true;
    }

    // Si on avait déjà flaggé, mais que le cart n'a pas les attrs, on retente quand même.
    if (hasSessionFlag()) {
      console.warn("[trk] Session flag was set but cart missing attrs. Retrying sync.");
    }

    for (let i = 0; i <= retries; i++) {
      try {
        console.log(`[trk] Sync attempt ${i + 1}/${retries + 1}`, payload);
        const ok = await updateCartAttributes(payload);
        if (ok) {
          setSessionFlag(); // IMPORTANT: flag uniquement sur succès
          return true;
        }
      } catch (e) {
        console.error("[trk] Error updating cart attributes:", e);
      }
      // petit backoff
      await new Promise((res) => setTimeout(res, 150 * (i + 1)));
    }

    return false;
  }

  // 1) Sync dès que possible au chargement
  syncIfNeeded({ retries: 2 });

  // 2) Bonus: retente juste avant checkout (navigation = risque d'annulation)
  document.addEventListener(
    "click",
    (e) => {

      const el = e.target.closest(
        'a[href*="/checkout"], button[name="checkout"], input[name="checkout"]'
      );
      if (el) {
        // pas de retries ici, on veut être rapide
        syncIfNeeded({ retries: 0 });
      }
    },
    { capture: true }
  );
})();